import React from 'react';
import Button from '../form/Button';
import Subnav from '../subnav';
import { history } from '../../state/store';

const ConsultantDashboardEmptyPage = (restricted) => {
    console.log(restricted);
    return (
        <div className="page">
            <div className="page__subnav">
                <Subnav />
            </div>

            <div className="page__body">
                <h1>Welcome to the EHS PCMH Guide!</h1>
                <p>
                    The next step is to setup an organization. Each organization
                    in your account can have any number of practices and
                    organization-specific users.
                </p>
            
                {restricted.restricted === false?<Button
                    defaultText="Click Here to Create an Organization"
                    icon="fa-sitemap"
                    onClick={() => {
                        history.push('/consultant/organizations/new');
                    }}
                />:''}
            </div>
        </div>
    );
};

export default ConsultantDashboardEmptyPage;
